import BaseApi from "./baseApi";

class PriestApi extends BaseApi {
  async getAllPriests(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/getAllPriests",
      data: data,
      method: "post",
    });
  }

  async getPriestDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/priest/getPriestDetail",
      data: data,
      method: "post",
    });
  }

  async checkPKPriest(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/checkPKPriest",
      data: data,
      method: "post",
    });
  }

  async createPriest(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/createPriest",
      data: data,
      method: "post",
    });
  }

  async editPriest(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/auth/editPriest",
      data: data,
      method: "post",
    });
  }

  async deletePriest(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/priest/deletePriest",
      data: data,
      method: "post",
    });
  }

  async participatedInRetreats(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/priest/participatedInRetreats",
      data: data,
      method: "post",
    });
  }
}

export default PriestApi;
